import React from "react";
import { PageHeader } from "@/components/ui-kit";
import { MetronomePanel } from "@/components/MusicTools";

export default function Tools() {
  return (
    <div>
      <PageHeader eyebrow="Keep time" title="Metronome & Tools"
        subtitle="A professional, stage-friendly metronome with tap tempo, subdivisions and voices." />
      <div className="max-w-md mx-auto">
        <MetronomePanel />
      </div>
    </div>
  );
}
